import loadable from '@loadable/component';
const Partners = loadable(() => import('./Components'));
export default Partners;
